export default __webpack_public_path__ + "static/media/DF.1bfa07ec.png";